<template>
  <div>
<!--    <el-menu
      v-if="$route.meta.showMenu !== false"
      :default-active="activeIndex"
      class="el-menu-demo"
      mode="horizontal"
      @select="handleSelect"
    >
      <el-tooltip
        class="item"
        effect="dark"
        content="手机逐台入库"
        placement="bottom"
      >
        <el-menu-item index="picRecongnitionTakePhoto" :router="true">
          <i class="el-icon-camera-solid"></i>
          手机逐台入库
        </el-menu-item>
      </el-tooltip>
      <el-menu-item index="BSNewPhone">
        <i class="el-icon-files"></i>
        手机批量入库
      </el-menu-item>
      &lt;!&ndash; <el-menu-item index="login">
        <i class="el-icon-camera-solid"></i>
        授权测试
      </el-menu-item> &ndash;&gt;
      <el-menu-item index="SNPage">
        <i class="el-icon-printer"></i>
        配件批量入库
      </el-menu-item>
      <el-menu-item index="outBound">
        <i class="el-icon-truck"></i>
        销售订单出库
      </el-menu-item>
      <el-menu-item index="reWarehousing">
        <i class="el-icon-truck"></i>
        售后管理
      </el-menu-item>
      &lt;!&ndash; <el-menu-item index="SNPageTest">
        <i class="el-icon-printer"></i>
        配件入库条形码打印测试
      </el-menu-item> &ndash;&gt;
      &lt;!&ndash; <el-menu-item index="inventoryCheck">
        <i class="el-icon-edit-outline"></i>
        盘点库存
      </el-menu-item> &ndash;&gt;
      &lt;!&ndash; <el-menu-item index="returnToSupplier">
        <i class="el-icon-sold-out"></i>
        未入库退货
      </el-menu-item> &ndash;&gt;
      &lt;!&ndash; <el-menu-item index="returnToFactory">
        <i class="el-icon-sold-out"></i>
        返厂维修
      </el-menu-item> &ndash;&gt;
      &lt;!&ndash; <el-menu-item index="accessoriesLossReport">
        <i class="el-icon-warning-outline"></i>
        配件报损
      </el-menu-item> &ndash;&gt;
      <el-menu-item index="anchorView">
        <i class="el-icon-s-platform"></i>
        主播视图
      </el-menu-item>
    </el-menu>-->
    <div class="layout-content">
      <div class="layout-content-main">
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>
<script>
/*import { authorization } from "ali-oss/lib/common/signUtils";
import axios from "axios";*/
export default {
  data() {
    return {
      /*activeIndex: "",
      userEmail:""*/
    };
  },
  created() {
    /*this.authorizedLogin()
    this.getToken();*/
  },
  methods: {
   /* // handleSelect(name) {
    //   this.$router.push({ name: name });
    // },
    // authorizedLogin() {
    //   window.location.href =
    //     "https://monkeyshop.mangkeyi.com/acc/oidc-authorize?response_type=code&client_id=62154d6bae138725a22b&redirect_uri=http://localhost:8080&scope=openid email";
    // },
    // login() {
    //   // 创建一个新的 Axios 实例专用于 /orderListApi 请求
    //   const loginApiInstance = axios.create({
    //     baseURL: "/loginApi",
    //   });
    //   //使用FormData对象发送POST请求
    //   loginApiInstance
    //     .get("monkeyshop/user/login/" + this.GLOBAL.userEmail)
    //     .then((res) => {
    //       // this.tableData = res.data.data;
    //       if (res.data.code == 500) {
    //         alert(res.data.msg);
    //       }
    //     })
    //     .catch(function (error) {
    //       console.log(error);
    //     });
    // },
    // getToken() {
    //   const currentUrl = window.location.toString();
    //   const urlObject = new URL(currentUrl);
    //   const searchParams = new URLSearchParams(urlObject.search);
    //   const code = searchParams.get("code");
    //   if (code !== null) {
    //     axios({
    //       method: "post",
    //       url: "api/oidcAuthentication/token",
    //       data: {
    //         code: code,
    //         redirect_uri: "http://localhost:8080",
    //         grant_type: "authorization_code",
    //         client_id: "62154d6bae138725a22b",
    //       },
    //       headers: {
    //         "Content-Type": "application/x-www-form-urlencoded",
    //       },
    //     })
    //       .then((res) => {
    //         const oidctoken = res.data.data.accessToken;
    //         console.log(
    //           oidctoken,
    //           res.data.data.accessToken,
    //           "res.data.data.accessToken"
    //         );
    //         axios({
    //           method: "get",
    //           url: "openApi/oidcAuthentication",
    //           // data:{
    //           //   "oidctoken": oidctoken
    //           // },
    //           headers: {
    //             // "Content-Type": "application/x-www-form-urlencoded"
    //             oidctoken: oidctoken,
    //           },
    //         })
    //           .then((res) => {
    //             this.GLOBAL.userEmail = res.data.result.email;
    //             console.log(this.GLOBAL.userEmail, "userEmail");
    //             this.login();
    //           })
    //           .catch((error) => {
    //             console.log(error, "error");
    //           });
    //       })
    //       .catch((error) => {
    //         console.log(error, "error");
    //       });
    //   } else {
    //     window.location.href =
    //       "https://monkeyshop.mangkeyi.com/acc/oidc-authorize?response_type=code&client_id=62154d6bae138725a22b&redirect_uri=http://localhost:8080&scope=openid email";
    //   }
    // },*/
  },
};
</script>
<style scoped>
.el-menu--horizontal > .el-menu-item.is-active {
  border-bottom: 2px solid #c0c4cc;
  color: #303133;
  font-weight: 700;
}
.el-menu-item [class^="el-icon-"] {
  width: 24px;
  text-align: center;
  font-size: 18px;
  vertical-align: middle;
}
</style>



// WEBPACK FOOTER //
// src/views/homepage.vue